import ShopFunc from "@/pcomponents/common/content/shop/order/func/shop_func";
import SelectTab from "@/pcomponents/common/crud/write/select_tab";

function TopTabArea(props: any) {
  let myProps = {
    listOpt: {},
    setListOpt: (inData: any) => { },
    list: (inData: any) => { },
    ...props
  };
  let select_order_state_arr = ShopFunc.select_order_state_arr;
  select_order_state_arr=[
    { value: "", text: "전체" },
    ...select_order_state_arr,
    { value: "pay_after_all", text: "결제이후모두" },
  ];

  return (
    <div>
      <SelectTab
        select_arr={select_order_state_arr}
        value={myProps.listOpt.s_state}
        is_same_value_empty={false}
        on_select={(value: string) => {
          myProps.list({
            s_state: value,
            now_page: 1
          });
        }}
      ></SelectTab>
    </div>
  );
};
export default TopTabArea;